<content *ngIf="eidosHtmlConfiguration"
  [innerHTML]="eidosHtmlConfiguration.templateResolved">
</content>
